module.exports = __webpack_public_path__ + "static/tails_right-87a54caec51bfd4f1b6835373f641a96.png";